import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'defaultCurrency',
})
export class DefaultCurrencyPipe implements PipeTransform {
  constructor() {}

  transform(
    value: number,
    compact: boolean = false,
    showDashes: boolean = false
  ): string {
    if (value == 0 && showDashes) {
      return '--';
    }

    if (compact) {
      let formatter = Intl.NumberFormat('en', {
        notation: 'compact',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
      return formatter.format(value) + ' MWK';
    }
    return (
      Number(value)
        .toFixed(2)
        .replace(/\d(?=(\d{3})+\.)/g, '$&,') + ' MWK'
    );
  }
}
